const module = 'admin'
const app = 'notifications'

export default {
  'api:admin:notifications:notification:list': `/${module}/${app}/notifications`,
  'api:admin:notifications:notification:detail': `/${module}/${app}/notifications/:id`,
  'api:admin:notifications:broadcast:list': `/${module}/${app}/broadcast`,
  'api:admin:notifications:broadcast:detail': `/${module}/${app}/broadcast/:id`,
}